import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { useSingleEffect } from 'react-haiku';

import Read from 'containers/Teacher/Students/Read';

import { useAppStore } from 'store/useAppStore';

const Users = () => {
	// Use app's store
	const setSection = useAppStore(state => state.setSection);

	// Set section on mount
	useSingleEffect(() => setSection('/users'));

	return (
		<Switch>
			{/* Webinar collection */}
			<Route exact path="/users">
				<Read />
			</Route>

			{/* Webinar's profile */}
			<Route path="/users/:section?/:id(\d+)">
				<div>Profile</div>
			</Route>
		</Switch>
	);
};

export default Users;
